import { useQuery } from "react-query";
import { get, showError } from "../../../../../store/api";

export const useQueryCardTypes = () => {
  return useQuery(
    ["useQueryCardTypes"],
    async () => {
      try {
        const { data } = await get(
          `${import.meta.env.VITE_API}/v1/card/card-name-list`
        );

        return data;
      } catch (err) {
        showError(err);
        return {};
      }
    },
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};
